import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ApiService from "../services/apiService"; // adjust path as needed

type UsePaginatedFetchProps = {
  endpoint: string;
  pageSize?: number;
  transform?: (data: any[]) => any[];
  initialSearchQuery?:string;
  filterOn?:string,
  sortBy?:string,
  enabled?:boolean,
  refreshKey?:number
};

export const usePagination = ({ endpoint, pageSize = 10, transform,initialSearchQuery,filterOn,sortBy,enabled,refreshKey }: UsePaginatedFetchProps) => {
  const [data, setData] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const[sort,setSortBy] = useState<string>('')
  const[fromDate,setFromDate] = useState<any>()
  const[toDate,setToDate] = useState<any>()
  const[searchQuery,setSearchQuery] = useState<string>(initialSearchQuery||'')
  const[id,setId] = useState(null)
  
  const fetchData = async () => {
    setLoading(true);
    try {
        
      const response = await ApiService.axiosApi(endpoint, {
        method: "GET",
        params: { pageNumber,
           pageSize,
           filterOn,
           filterQuery:searchQuery || null,
           sortBy:sort||null,
           isAssending: true,
           fromDate: fromDate,
           toDate:toDate,
           chakId:id,

           
         },
        
      });
    
      if (response.success) {
       
        const items = transform ? transform(response.data.data) : response.data.data;
        setData(items);
         
        setTotalCount(response.data.totalCount)
        // adjust based on your backend
        
      } else {
        console.error(response.message || "Failed to fetch data");
      }
    } catch (err: any) {
      toast.error(err.status || "Fetch error");
    } finally {
      setLoading(false);
    }
  
  };

  useEffect(() => {
    if(enabled){
    fetchData();
    }
  }, [pageNumber, refresh, endpoint, pageSize,searchQuery,sort,enabled,refreshKey]);

  return {
    data,
    pageNumber,
    setPageNumber,
    pageSize,
    totalCount,
    setRefresh,
    loading,
    searchQuery,
    setSearchQuery,
    filterOn,
    setSortBy,
    setFromDate,
    setToDate,
    setId,
    id,
    fromDate,
    toDate
  };
};
